$(document).ready(function(){
  if ($('.product-main-slider .product__media-item').length > 1) {
    
   $('.product-main-slider-mobile').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true, 
  responsive: [        
      {
          breakpoint: 767,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
          }
      }    
    ] 
  });
  } else {
    $(".product__media-wrapper").addClass("expended");
  }

// Initially hide all accordion content except the first one
//$('.acc-text').hide();
//$('.acc-text:first').show();
$('.acc-head:first').addClass('active');

$('.acc-head').click(function() {
    var content = $(this).next('.acc-text');
    if (content.is(':visible')) {
        content.slideUp();
        $(this).removeClass('active');
    } else {
        $('.acc-text').slideUp();
        $('.acc-head').removeClass('active');
        content.slideDown();
        $(this).addClass('active');
    }
});
if ($(window).width() < 768) {
 

  $('.footer-block--menu .footer-block__details-content').hide();
  $('.footer-block--menu .footer-block__heading').click(function() {
    $(this).next('.footer-block--menu .footer-block__details-content').slideToggle();
    $(this).toggleClass('active');
  });

}  

  
setTimeout(function(){
      $('.swym-button-bar').appendTo('.product__title');
    }, 2000); 
  




    $(document).on('click', '.spf-product__swatchs > span', function() {
        var $this = $(this);
        setTimeout(function() {
            $this.parent().parent().next('.spf-product__form')
                 .find('.spf-product__form-btn-addtocart')
                 .trigger('click');
        }, 1000); // 1000 milliseconds = 1 second
    });
   document.addEventListener('DOMContentLoaded', function() {
    var backButton = document.getElementById('back-button');

    if (backButton) {
        backButton.addEventListener('click', function() {
            // Navigate back to the last visited page
            window.history.back();
        });
    }
}); 

////////
 // Function to update the selected class based on the current selection
    function updateSelectedClass() {
        // Get the currently selected value from the label
        var selectedValue = $(".sort-by-toggle span").text().trim();
        
        // Remove the 'selected' class from all options
        $("#globo-dropdown-sort_options span").removeClass("selected");
        
        // Find the corresponding span with the same data-sort value and add the 'selected' class
        $("#globo-dropdown-sort_options span").each(function() {
            if ($(this).text().trim() === selectedValue) {
                $(this).addClass("selected");
            }
        });
    }

    // Periodic check for changes in the .sort-by class
    setInterval(function() {
        updateSelectedClass();
    }, 500); // Check every 500ms

    // Initial update on page load
    updateSelectedClass();




///////////// for menu order sort
 /// mobile
  // Function to sort the links alphabetically
  function sortLinksAlphabetically() {
    // Select all <a> elements inside .designer_submenu and detach them from the DOM
    var $links = $('.designer_submenu a').detach();

    // Sort the <a> elements alphabetically based on the text inside them
    $links.sort(function(a, b) {
      return $(a).text().trim().localeCompare($(b).text().trim());
    });

    // Append the sorted <a> elements back to the .designer_submenu container
    $('.designer_submenu').append($links);
  }

  // Call the function to sort the links
  sortLinksAlphabetically();


  /// desktop
   // Function to sort the list items alphabetically
  function sortListAlphabetically(parentList) {
    $(parentList).each(function() {
      var $list = $(this);
      var $items = $list.children("li");

      $items.sort(function(a, b) {
        return $(a).find('a').text().trim().localeCompare($(b).find('a').text().trim());
      });

      $items.detach().appendTo($list);
    });
  }

  // Sort the top-level menu items
  sortListAlphabetically('.mega-menu__list');

  // Sort the second-level menu items
  sortListAlphabetically('.mega-menu__list > li > ul');





/// for read more
   $(".narrow #read-more-btn").click(function(e) {
  e.preventDefault();
  $(this).parents('.narrow').addClass('hidden');
  $('.collection-hero__description.rte.expanded.hidden').removeClass('hidden');
});


$(".expanded #read-less-btn").click(function(e) {
  e.preventDefault();
  $(this).parents('.expanded').addClass('hidden');
  $('.collection-hero__description.rte.narrow.hidden').removeClass('hidden');
});



//////////////// for back button -- countinue shopping ///////////
   // Store the current page link in localStorage as 'currentlink'
    localStorage.setItem('currentlink', window.location.href);

    // Store the last page link in localStorage as 'lastlink' when the page is about to be unloaded
    $(window).on('beforeunload', function() {
        var currentURL = window.location.href;
        var cartURL = 'https://beachcafe-store.myshopify.com/cart';
        var previousURL = localStorage.getItem('currentlink');

        // Check if the current URL is the cart page
        if (currentURL !== cartURL) {
            // If the current URL is not the cart page, save the previous URL as 'lastlink'
            localStorage.setItem('lastlink', previousURL);
        }
    });

    // On click of the button with the class 'cart_back-button', redirect to the last link
    $('.cart_back-button').on('click', function() {
        var lastLink = localStorage.getItem('lastlink');
        if (lastLink) {
            // Check if the lastLink is not the current page to avoid unnecessary redirects
            if (window.location.href !== lastLink) {
                window.location.href = lastLink;
            } else {
                // If the lastLink is the same as the current page, redirect to a fallback URL
                window.location.href = 'https://beachcafe-store.myshopify.com/';
            }
        } else {
            // Redirect to the specified URL if lastlink is not found
            window.location.href = 'https://beachcafe-store.myshopify.com/';
        }
    });
 

  
/////+++++++++++++++
$('tbody').on('click', function() {
  setTimeout(function() {
      $('.cart_back-button').on('click', function() {
        var lastLink = localStorage.getItem('lastlink');
        if (lastLink) {
            window.location.href = lastLink;
           //window.history.back();
        } else {
            //alert('No last link found');
          //window.history.back();
          window.location.href = 'https://beachcafe-store.myshopify.com/';
        }
    });
  },1000);
});
/////////// for chat icon
// function applyBottomStyle() {
//     if (window.innerWidth < 767) {
//         document.getElementById('launcher').style.bottom = '50px';
//     } else {
//         document.getElementById('launcher').style.bottom = '0px'; // Reset or remove the style
//     }
// }

// // Apply the style on page load
// applyBottomStyle();

// Reapply the style on window resize
//window.addEventListener('resize', applyBottomStyle);
/////////////////////////
 
  // Function to check URL and display message
  function checkIfSubscribed() {
    var url = window.location.href;
    var targetParams = '?contact%5Btags%5D=newsletter&form_type=customer';
    
    // Check if the URL contains the specific query parameters
    if (url.indexOf(targetParams) !== -1) {
      // Check if the message is already present
      if ($('#alreadySubscribedMessage').length === 0) {
        // Create the message element
        var message = '<p id="alreadySubscribedMessage" class="newsletter-form__message form__message">This email is already subscribed.</p>';
        
        // Add the message above the form field wrapper
        $('.newsletter-form__field-wrapper').before(message);
      }
    }
  }
  setTimeout(function () { 
    // Run the check on page load
    checkIfSubscribed(); 
  },3000);
  // Optionally, you might want to re-run the check on form submission if the page might be reloaded or dynamically updated
  $('#ContactFooter').on('submit', function() {
    // Run the check again when the form is submitted
    checkIfSubscribed();
  });
 
});

 $(window).on('load', function() {
    var url = window.location.href;
    var targetParams = '?contact%5Btags%5D=newsletter&form_type=customer';
    
    // Check if the URL contains the specific query parameters
    if (url.indexOf(targetParams) !== -1) {
      // Check if the message is already present
      if ($('#alreadySubscribedMessage').length === 0) {
        // Create the message element
        var message = '<p id="alreadySubscribedMessage" class="newsletter-form__message form__message">This email is already subscribed.</p>';
        
        // Add the message above the form field wrapper
        $('.newsletter-form__field-wrapper').before(message);
      }
    }
 }) 



/////////////////////// Klaviyo notify me button on sile product page ////////////////
///////// for font 
function applyStylesToIframe() {
        // Get the iframe element
        var iframe = document.getElementById('klaviyo-bis-iframe');

        // Ensure the iframe exists and has loaded content
        if (iframe && iframe.contentDocument) {
            var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

            // Create the style element
            var style = iframeDoc.createElement('style');
            style.innerHTML = `
              @font-face {
                font-family: 'Futura-Book';
                src: url('https://cdn.shopify.com/s/files/1/0636/2916/4727/files/FuturaCyrillicBook.ttf?v=1720691395');
              }
              
              #klaviyo-bis-modal * {
                font-family: 'Futura-Book' !important;  
              }
              #klaviyo-bis-modal * p {
                  font-size: 18px;
                  color: #777373;
              }
              #klaviyo-bis-modal * .control-group button {
                  background: rgb(176, 96, 164);
                  border-radius: 6px;
                  border-style: none;
                  border-color: rgb(61, 75, 199);
                  border-width: 2px;
                  color: rgb(255, 255, 255);
                  font-family: Futura-Book, Arial, "Helvetica Neue", Helvetica, sans-serif;
                  font-size: 16px;
                  font-weight: 400;
                  letter-spacing: 0px;
                  line-height: 1;
                  font-style: normal;
                  white-space: normal;
                  padding-top: 0px;
                  padding-bottom: 0px;
                  text-align: center;
                  word-break: break-word;
                  align-self: flex-end;
                  cursor: pointer;
                  pointer-events: auto;
                  height: 54px;
                  width: 100%;
              }
            `;
            
            // Append the style to the iframe's head
            iframeDoc.head.appendChild(style);
            //console.log("Styles with font size applied to iframe");
        } else {
            //console.error('Iframe or its content is not accessible.');
        }
    }

    // Run the function every second
    var intervalId = setInterval(function () { 
        applyStylesToIframe();
    }, 1000);
    
    // Optionally, stop after a certain number of attempts
    setTimeout(function () {
        clearInterval(intervalId);
    }, 2000); // Stop after 2 seconds


////////////////////////
   // Function to handle the behavior when the button's `display` style changes
  function handleStyleChange() { 
    // Select the form inside `.not_top_bottom`
    const form = document.querySelector(".not_top_bottom product-form form");
    const page = document.querySelector("product-info");

    if (form) {
      console.log("Form found");

      // Check if the <a> element with class "btn klaviyo-bis-trigger" exists
      const btn = form.querySelector("a.btn.klaviyo-bis-trigger");
      if (btn) {
        console.log("Button found");

        if (btn.style.display === "none") {
          console.log("The button has inline style 'display: none'.");
          // Remove the button from the new location if it's hidden
          const variantFieldset = page.querySelector("variant-selects");
          if (variantFieldset) {
            const existingClone = variantFieldset.querySelector(
              "a.btn.klaviyo-bis-trigger"
            );
            if (existingClone) {
              existingClone.remove();
              console.log("Button removed from variantFieldset");
            }
          }
        } else {
          console.log("The button does not have 'display: none' inline style.");
          // Append the button to the new location if it's visible
          const variantFieldset = page.querySelector("variant-selects");
          if (variantFieldset) {
            const clonedBtn = btn.cloneNode(true); // Clone the button
            clonedBtn.style.display = ""; // Ensure the cloned button is visible
            variantFieldset.appendChild(clonedBtn); // Append the button to the fieldset
            console.log("Button appended to variantFieldset");
          }
        }
      }
    }
  }

  // Function to wait for the button to be available and then start the observer
  function waitForButton() {
    // Select the button to observe for style changes
    const btnToObserve = document.querySelector("a.btn.klaviyo-bis-trigger");

    if (btnToObserve) {
      console.log("Button found, setting up MutationObserver");
      applyStylesToIframe();
        handleStyleChange();
      // Set up the MutationObserver to detect style changes on the button
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "style"
          ) {
            console.log("Detected a style change on the button");
            handleStyleChange(); // Call the function when the style changes
          }
        }
      });

      // Start observing the button for style attribute changes
      observer.observe(btnToObserve, { attributes: true, attributeFilter: ["style"] });
    } else {
      //console.log("Button not found, retrying...");
      setTimeout(waitForButton, 500); // Retry after 500ms
    }
  }

  // Wait for the document to be fully loaded before running the script
  document.addEventListener('DOMContentLoaded', function() {
    console.log("Page fully loaded, checking for the button");
    
    // Run the code immediately on page load
    handleStyleChange(); 

    // Then start waiting for the button to observe changes
    waitForButton(); 
  }); 

///////////////////////// for recmendations
window.onload = function() {
    function checkRelatedItemsSection() {
        // Check if the section is loaded
        var section = $("section.shopify-section.section.related_items_new");
        
        if (section.length > 0) {
            // Section is loaded, find the ul and count li elements with the specified class
            var ul = section.find("ul.grid.product-grid");
            var liCount = ul.find("li.grid__item.related_grid_new").length;

            if (liCount < 4) {
                console.log("Less than 4 related items found, fetching random products...");

                // Fetch random additional products from 'new-in' collection
                fetchRandomProducts(4 - liCount); // Number of products needed to reach 4
            } else {
                console.log("Number of related items:", liCount);
            }

            // Stop checking since the section is found and handled
            clearInterval(checkInterval);
        }
    }

    function fetchRandomProducts(count) {
        // Making an AJAX call to fetch products from the 'new-in' collection
        $.ajax({
            url: '/collections/new-in?view=ajax', // Adjust the view parameter as per your theme
            method: 'GET',
            success: function(data) {
                // Parse the HTML response
                var products = $(data).find("li.grid__item").filter(function() {
                    // Filter out products that contain the 'hidden' tag or are unavailable
                    var isHidden = $(this).data('tags') && $(this).data('tags').includes('hidden');
                    var isAvailable = !$(this).find('.sold-out-badge').length; // Assuming a class indicates sold-out items
                    return !isHidden && isAvailable;
                });

                // Shuffle the filtered products to get random ones
                var shuffledProducts = shuffle(products);

                // Append only the required number of random products to the related items section
                var productsToAppend = shuffledProducts.slice(0, count);
                $("section.shopify-section.section.related_items_new ul.grid.product-grid").append(productsToAppend);

                console.log("Appended random products:", productsToAppend.length);
            },
            error: function(xhr, status, error) {
                console.error("Failed to fetch products:", error);
            }
        });
    }

    // Function to shuffle an array
    function shuffle(array) {
        var currentIndex = array.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }

    // Run the check periodically until the section is found
    var checkInterval = setInterval(checkRelatedItemsSection, 500); // Check every 500 milliseconds
};
